<mat-dialog-content class="modal">
  <h3>Nicht in unserem Produktfokus enthalten</h3>
  <p>
    Derzeit bieten wir für KWK-Anlagen leider keine Angebote für die Direktvermarktung an. Wir
    werden unseren Fokus zukünftig auf Solar und Wind ausrichten.
  </p>
  <p>
    Alternativ können wir Ihnen empfehlen, über unseren Partner Erdgas Südwest die Direktvermarktung
    für Ihre KWK-Anlage anzufragen:
  </p>
  <p>
    <a
      href="https://www.erdgas-suedwest.de/unternehmen/direktvermarktung"
      class="black-url"
      target="_blank"
    >
      <u>Erdgas Südwest (erdgas-suedwest.de)</u>
    </a>
  </p>
  <p>Wir bedauern diesen Schritt und bedanken uns für Ihr Verständnis.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="modal-button" (click)="closeDialog()">Schließen</button>
</mat-dialog-actions>
